import { Response } from '@custom-types/Response';

import apiFn from './api-service';

// add feature flag here as enum.
export enum FlagKey {}

export interface Flag {
  enabled: boolean;
  keyId: FlagKey;
  resourceType: string;
  resourceId: string;
}

export const getEvent = (id: string) => {
  const api = apiFn(`/api/cms/v1/views/events/${id.toString()}/feature-flag-values`);

  return api.get('').then((response: Response<Flag[]>) => response.data.data);
};

export const getSystem = () => {
  const api = apiFn('/api/v1/views/sys/feature-flag-values');

  return api.get('').then((response: Response<Flag[]>) => response.data.data);
};
